import React from 'react';
import cx from 'classnames';
import { Card } from '../Card';
import styles from './index.scss';

interface CardListProps {
  className?: string;
  size?: number;
  direction?: 'horizontal' | 'vertical';
  noTitle?: boolean;
}

export const CardList = ({
  className,
  size = 8,
  direction = 'vertical',
  noTitle = false,
}: CardListProps) => {
  return (
    <section
      className={cx(
        styles.CardList,
        {
          [styles.CardListNoTitle]: noTitle,
        },
        className,
      )}>
      <div>
        {Array(size)
          .join(' ')
          .split(' ')
          .map((_, j) => {
            return <Card key={j} direction={direction} />;
          })}
      </div>
    </section>
  );
};
